import React from 'react'
import './LeaderBoardTabs.scss'

export function LeaderBoardTabs() {
  return (
    <ul className="leaderboard-tabs-list">
      <li className="leaderboard-tab">
        <button> This week </button>
      </li>
      <li className="leaderboard-tab">
        <button> This month </button>
      </li>
      <li className="leaderboard-tab">
        <button> All time </button>
      </li>
    </ul>
  )
}
